import {Field} from "../lib/wa-2.0";
import CheckboxTree, {Node} from "react-checkbox-tree";
import Select from "react-select";
import React, {useEffect, useState} from "react";
import ChooseCategoriesApi, {CategoryNestedSet} from "../api/ChooseCategoriesApi";

export interface SelectProductsState {
    selectType: string,
    productCollectionType?: string,
    selectedCategories?: string[],
    selectedSets?: { label: string, value: string }[],
}

interface SelectProductsCategoriesOrSetsProps extends SelectProductsState {
    changeState: (state: SelectProductsState) => void,
    addFromExportVariant?: boolean
}

export const SelectProductsCategoriesOrSets = (props: SelectProductsCategoriesOrSetsProps) => {

    const [categories, setCategories] = useState<Node[]>([])
    const [sets, setSets] = useState<{ label: string, value: string }[]>([])
    const [expandedCategories, setExpandedCategories] = useState<string[]>([])
    const state: SelectProductsState = {
        selectType: props.selectType,
        productCollectionType: props.productCollectionType,
        selectedCategories: props.selectedCategories,
        selectedSets: props.selectedSets ? props.selectedSets : [],
    };

    useEffect(() => {
        ChooseCategoriesApi.getAllSetsAndCategories().then((result) => {

            const categories = convertToNodeList(result.data.data.categories)
            setCategories(categories)
            setExpandedCategories(findExpandedIfChildrenHas(props.selectedCategories ?? [], categories));

            const sets = []

            for (const set of result.data.data.sets) {
                const obj = {
                    label: set.name,
                    value: set.id
                }
                sets.push(obj)
            }
            setSets(sets)

        });
    }, []);

    return <>
        <Field label={'Товары'} isRequired={true}>
            <div className="toggle">
                {props.addFromExportVariant && <span
                    onClick={() => props.changeState({...state, selectType: 'fromExport'})}
                    className={props.selectType === 'fromExport' ? "selected" : ""}>
                    Из экспорта
                </span>}
                <span
                    className={props.selectType === 'all' ? "selected" : ""}
                    onClick={() => props.changeState({...state, selectType: 'all'})}
                >Все</span>
                <span
                    className={props.selectType === 'collection' ? "selected" : ""}
                    onClick={() => props.changeState({...state, selectType: 'collection'})}
                >Выбрать</span>
            </div>
        </Field>
        {props.selectType === 'collection' &&
            <Field label={''}>
                <div className="wa-select smaller custom-mb-12">
                    <select name="" value={props.productCollectionType}
                            onChange={(e) => props.changeState({...state, productCollectionType: e.target.value})}>
                        <option value="categories">Категории</option>
                        <option value="sets">Списки</option>
                    </select>
                </div>
                {(props.productCollectionType === 'categories' || !props.productCollectionType) &&
                    <CheckboxTree
                        nodes={categories}
                        checked={props.selectedCategories}
                        expanded={expandedCategories}
                        onCheck={(check: string[]) => props.changeState({...state, selectedCategories: check})}
                        checkModel={"all"}
                        noCascade={true}
                        onExpand={expand => setExpandedCategories(expand)}
                        icons={{
                            parentClose: '',
                            parentOpen: '',
                            leaf: ''
                        }}
                    />
                }
                {props.productCollectionType === 'sets' &&
                    <div style={{width: '500px'}}>
                        <Select
                            placeholder={"Выбрать..."}
                            isMulti
                            closeMenuOnSelect={false}
                            options={sets}
                            value={state.selectedSets}
                            onChange={(value) => props.changeState({...state, selectedSets: [...value]})}
                        />
                    </div>
                }
            </Field>
        }
    </>
}

function convertToNodeList(categories: CategoryNestedSet[]): Node[] {
    const nodes: Node[] = []
    for (const category of categories) {
        const newNode: Node = {
            label: category.name,
            value: category.id,
        }
        const children = convertToNodeList(Object.values(category.categories))
        if (children.length > 0) {
            newNode.children = children
        }
        nodes.push(newNode)
    }
    return nodes
}

function findExpandedIfChildrenHas(ids: string[], categories: Node[]): string[] {
    const foundCategories = new Set<string>()
    for (const category of categories) {
        if (category.children) {
            for (const child of category.children) {
                let found = false
                for (const id of ids) {
                    if (+id === +child.value) {
                        found = true
                    }
                }
                if (found) {
                    foundCategories.add(category.value)
                }
            }
            const expand = findExpandedIfChildrenHas(ids, category.children)
            for (const cat of expand) {
                foundCategories.add(cat)
            }
        }

    }

    return Array.from(foundCategories)
}